export default {
  '_b._qhyy': 'Cambia lingua',

  '_a._jzz': 'Caricamento...',
  '_a._jzgd': 'Carica più',
  '_a._wct': 'Benvenuto su',
  '_a._gd': 'Più',
  '_a._bf': 'Riproduci',
  '_a._bcz': 'Salvataggio...',
  '_a._sctp': 'Carica immagine',

  '_dl._qssyx': 'Inserisci la tua email',
  '_dl._qssmm': 'Inserisci la tua password',
  '_dl._ann': 'Accedi',
  '_dl._hmyzh': 'Non hai un account?',
  '_dl._qzc': 'Registrati',
  '_dl._yzhl': 'Hai già un account?',
  '_dl._qdl': 'Accedi',
  '_dl._srqrmm': 'Conferma la password',
  '_dl._sryqm': 'Inserisci il codice invito',
  '_dl._sryzm': 'Inserisci il codice di verifica',
  '_dl._ljzc': 'Registrati ora',
  '_dl._zcbsty': "La registrazione implica l'accettazione della",
  '_dl._yszc': 'Privacy Policy',
  '_dl._lcmmbyy': 'Le password non corrispondono',

  '_yzm._fsyzm': 'Invia codice di verifica',
  '_yzm._cxfs': '({time}) Reinvia',
  '_yzm._fsz': 'Invio in corso...',
  '_yzm._fscg': 'Inviato con successo',

  '_h._zrm': 'Più popolare',
  '_h._zxd': 'Più recente',
  '_h._phb': 'Classifica',
  '_h._qz': 'Sfondi',
  '_h._ssww': 'Cerca',
  '_h._lsjl': 'Cronologia',
  '_h._gd': 'Più',
  '_h._dl': 'Accedi',
  '_h._ye': 'Saldo',
  '_h._dj': 'Congelato',
  '_h._ybp': 'Dashboard',
  '_h._wdqb': 'Il mio portafoglio',
  '_h._scjl': 'Preferiti',
  '_h._xxzx': 'Centro messaggi',
  '_h._fxhy': 'Condividi con amici',
  '_h._bzzx': 'Centro assistenza',
  '_h._ggtf': 'Posizionamento pubblicitario',
  '_h._bqtz': 'Investimento copyright',
  '_h._sz': 'Impostazioni',

  '_sy._jx': 'In evidenza',
  '_sy._xpfb': 'Nuove uscite',
  '_sy._gdsp': 'Altri video',

  '_qz._jbqz': 'Collezione di sfondi pregiati',
  '_qz._ssqz': 'Cerca sfondo',
  '_qz._qb': 'Tutti',
  '_qz._zrfg': 'Paesaggi naturali',
  '_qz._cxys': 'Arte astratta',
  '_qz._csjz': 'Architettura urbana',
  '_qz._dmyx': 'Anime e giochi',
  '_qz._yzxk': 'Cosmo e stelle',
  '_qz._yl': 'Anteprima',
  '_qz._xzqz': 'Scarica sfondo',
  '_qz._fbl': 'Risoluzione',
  '_qz._fl': 'Categoria',
  '_qz._jzz': 'Caricamento',
  '_qz._myzdpp': 'Nessun sfondo corrispondente trovato',

  '_sp._xyjscl': 'Sblocco richiesto per guardare',
  '_sp._cz': 'Ricarica',
  '_sp._jsqj': 'Sblocca tutti gli episodi',
  '_sp._jsbj': 'Sblocca questo episodio',
  '_sp._sc': 'Preferito',
  '_sp._fx': 'Condividi',
  '_sp._jsqjjs': 'Confermi il pagamento di {a} per sbloccare tutti gli episodi?',
  '_sp._jsbjjs': 'Confermi il pagamento di {a} per sbloccare questo episodio?',
  '_sp._zfz': 'Elaborazione pagamento...',
  '_sp._qrzf': 'Conferma pagamento',
  '_sp._qx': 'Annulla',

  '_qz._smrc': 'Alba montana',
  '_qz._cxjh': 'Geometria astratta',
  '_qz._dsyj': 'Vista notturna urbana',
  '_qz._dmfj': 'Paesaggio anime',
  '_qz._hhxk': 'Cielo stellato',
  '_qz._slmw': 'Nebbia forestale',
  '_qz._scld': 'Flusso di colore',
  '_qz._xdjz': 'Architettura moderna',

  '_qb._cbjl': 'Cronologia depositi',
  '_qb._jyjl': 'Cronologia transazioni',
  '_qb._bddz': 'Indirizzi associati',
  '_qb._txjl': 'Cronologia prelievi',

  '_m._tcdl': 'Disconnetti',
  '_m._cb': 'Deposita',
  '_m._tb': 'Preleva',

  '_cb._ssdz': 'Cerca valuta o indirizzo',
  '_cb._bz': 'Valuta',
  '_cb._je': 'Importo',
  '_cb._dz': 'Indirizzo',
  '_cb._sj': 'Ora',
  '_cb._cz': 'Azione',
  '_cb._zwjl': 'Nessuna transazione ancora',
  '_cb._dny': 'Pagina {a} di {b}',
  '_cb._jyxq': 'Dettagli transazione',
  '_cb._jydz': 'Indirizzo transazione',
  '_cb._zt': 'Stato',
  '_cb._yqr': 'Confermato',
  '_cb._qb': 'Tutti',
  '_cb._jt': 'Oggi',
  '_cb._j7t': 'Ultimi 7 giorni',
  '_cb._j30t': 'Ultimi 30 giorni',
  '_cb._zw': 'Nessuno',
  '_cb._fzcg': 'Indirizzo copiato negli appunti',

  '_jyjl._ssdz': 'Cerca valuta o indirizzo',
  '_jyjl._lx': 'Tipo',
  '_jyjl._je': 'Importo',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Congelato',
  '_jyjl._sj': 'Ora',
  '_jyjl._cz': 'Azione',
  '_jyjl._zwjyjl': 'Nessuna transazione ancora',
  '_jyjl._czsx': 'Reimposta filtro',
  '_jyjl._dny': 'Pagina {a} di {b}',
  '_jyjl._jyxq': 'Dettagli transazione',
  '_jyjl._jylx': 'Tipo transazione',
  '_jyjl._jyje': 'Importo transazione',
  '_jyjl._jyhye': 'Saldo dopo transazione',
  '_jyjl._djye': 'Importo congelato',
  '_jyjl._jysj': 'Ora transazione',
  '_jyjl._jyzt': 'Stato transazione',
  '_jyjl._ywc': 'Completato',
  '_jyjl._qb': 'Tutti',
  '_jyjl._jt': 'Oggi',
  '_jyjl._j7t': 'Ultimi 7 giorni',
  '_jyjl._j30t': 'Ultimi 30 giorni',

  '_jyjl._tp1': 'Deposito',
  '_jyjl._tp2': 'Prelievo',
  '_jyjl._tp3': 'Pagamento',
  '_jyjl._tp4': 'Deposito',
  '_jyjl._tp5': 'Congela',
  '_jyjl._tp6': 'Guadagni',
  '_jyjl._tp7': 'Ricompensa invito',
  '_jyjl._tp8': 'Ricompensa accesso',
  '_jyjl._tp9': 'Guadagni promozione',
  '_jyjl._tp10': 'Ricompensa video',
  '_jyjl._tp11': 'Bonus registrazione',
  '_jyjl._tp12': 'Ritiro rifiutato',
  '_jyjl._tp13': 'Messaggio Pacchetto Rosso',

  '_jyjl._tp14': 'Trasferimento Interno',

  '_cb._shz': 'In revisione',
  '_cb._yyg': 'Approvato',
  '_cb._ybh': 'Rifiutato',

  '_bddz._tjdz': 'Aggiungi indirizzo',
  '_bddz._ssdz': 'Cerca indirizzo',
  '_bddz._bz': 'Valuta',
  '_bddz._dz': 'Indirizzo',
  '_bddz._sysj': 'Ultimo uso',
  '_bddz._cz': 'Azione',
  '_bddz._zwjl': 'Nessun indirizzo ancora',
  '_bddz._dny': 'Pagina {a} di {b}',
  '_bddz._dzewm': 'Codice QR indirizzo',
  '_bddz._fzdz': 'Copia indirizzo',
  '_bddz._dzxq': 'Dettagli indirizzo',
  '_bddz._wl': 'Rete',
  '_bddz._tjsj': 'Data aggiunta',
  '_bddz._bzwa': 'Nota',
  '_bddz._ntq': '{a} giorni fa',
  '_bddz._nxsq': '{a} ore fa',
  '_bddz._nfzq': '{a} minuti fa',
  '_bddz._ngg': 'Proprio ora',
  '_bddz._dzyfz': 'Indirizzo copiato negli appunti',
  '_bddz._scqr': 'Conferma eliminazione',
  '_bddz._scqrdz': 'Sei sicuro di eliminare questo indirizzo?',
  '_bddz._qr': 'Conferma',
  '_bddz._qx': 'Annulla',
  '_bddz._scdzcg': 'Indirizzo eliminato con successo',

  '_txjl._ztsx': 'Filtro per stato',
  '_txjl._qbzt': 'Tutti gli stati',
  '_txjl._shz': 'In revisione',
  '_txjl._ytg': 'Approvato',
  '_txjl._yjj': 'Rifiutato',
  '_txjl._ssdz': 'Cerca indirizzo o importo',
  '_txjl._bz': 'Valuta',
  '_txjl._je': 'Importo',
  '_txjl._dz': 'Indirizzo',
  '_txjl._zt': 'Stato',
  '_txjl._sj': 'Ora',
  '_txjl._cz': 'Azione',
  '_txjl._zwjl': 'Nessuna transazione ancora',
  '_txjl._czsx': 'Reimposta filtro',
  '_txjl._dny': 'Pagina {a} di {b}',
  '_txjl._jyxq': 'Dettagli transazione',
  '_txjl._skdz': 'Indirizzo di ricezione',
  '_txjl._jysj': 'Ora transazione',
  '_txjl._jyzt': 'Stato transazione',
  '_txjl._fzdz': 'Indirizzo copiato negli appunti',

  '_cbsq._bz': 'Valuta',
  '_cbsq._wl': 'Rete',
  '_cbsq._erwm': 'Codice QR',
  '_cbsq._fzdz': 'Copia indirizzo',

  '_txsq._bz': 'Valuta',
  '_txsq._wl': 'Rete',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Commissione',
  '_txsq._zxtx': 'Prelievo minimo',
  '_txsq._txdz': 'Indirizzo di prelievo',
  '_txsq._qxztxdz': 'Seleziona indirizzo di prelievo',
  '_txsq._txje': 'Importo prelievo',
  '_txsq._qsrtxje': 'Inserisci importo prelievo',
  '_txsq._yxyzm': 'Codice verifica email',
  '_txsq._qsryxyzm': 'Inserisci codice di verifica',
  '_txsq._ljtx': 'Preleva ora',

  '_jl._wxhd': 'I miei preferiti',
  '_jl._lsjl': 'Cronologia',

  '_xx._bt': 'Centro messaggi',
  '_xx._wjl': 'Nessun record',
  '_xx._zsmyxx': 'Nessun messaggio ancora',
  '_xx._sxxx': 'Aggiorna messaggi',
  '_xx._sxcg': 'Aggiornato con successo',

  '_fx._fxhy': 'Condividi con amici',
  '_fx._smfx': 'Scansiona il QR code per condividere',
  '_fx._jlsm': 'Descrizione ricompensa',
  '_fx._jlsm1': '1. Gli amici che inviti direttamente (Livello 1) ti danno il {a}% dei loro guadagni.',
  '_fx._jlsm2': '2. Gli amici invitati dai tuoi amici di Livello 1 (Livello 2) ti danno il {a}% dei loro guadagni.',
  '_fx._jlsm3': '3. Gli amici invitati dai tuoi amici di Livello 2 (Livello 3) ti danno il {a}% dei loro guadagni.',
  '_fx._fzlj': 'Copia link',

  '_bzzx._bzzx': 'Centro assistenza',
  '_bzzx._rhzczh': 'Come creare un account',
  '_bzzx._zclc': 'Processo registrazione',
  '_bzzx._rhzcxyh': 'Come registrarsi?',
  '_bzzx._rhzcxyh1': 'Clicca "Registrati", inserisci email, imposta password e completa la verifica email.',
  '_bzzx._rhcz': 'Come ricaricare?',
  '_bzzx._rhcz1': 'Processo ricarica',
  '_bzzx._rhcz2': 'Istruzioni dettagliate ricarica',
  '_bzzx._rhcz3': "Clicca Il Mio Portafoglio, Deposita, seleziona la criptovaluta e invia all'indirizzo fornito.",

  '_bzzx._rhjsdj': 'Come sbloccare mini-drama',
  '_bzzx._rhjsdj2': 'Clicca per sbloccare episodi singoli.',

  '_bzzx._rhtx': 'Come prelevare dal conto',
  '_bzzx._rhtx1': "1. Vai in Il Mio Portafoglio, Indirizzi di prelievo, aggiungi un nuovo indirizzo.<br>2. Clicca Preleva, seleziona la valuta, inserisci l'importo e attendi.",

  '_bzzx._qtwt': 'Altre domande',
  '_bzzx._qtwt1': "Come contattare l'assistenza?",
  '_bzzx._qtwt2': 'Contattaci via chat, email o telefono.',
  '_bzzx._myzdwt': 'Non trovi la risposta?',
  '_bzzx._khjybbzn': 'Il nostro team è felice di aiutarti.',
  '_bzzx._lxkf': 'Contatta assistenza',

  '_ggtf._bt1': 'Posizionamento pubblicitario',
  '_ggtf._splb': 'Lista video',
  '_ggtf._wcyd': 'La mia partecipazione',
  '_ggtf._hdbm': 'Codice evento',
  '_ggtf._tian': 'Giorni',
  '_ggtf._kssj': 'Ora inizio',
  '_ggtf._jssj': 'Ora fine',
  '_ggtf._ddvp': 'Raggiungi VIP livello {a}, media {b} partecipazioni',
  '_ggtf._hdzt': 'Stato evento',
  '_ggtf._wks': 'Non iniziato',
  '_ggtf._ycy': 'Partecipato',
  '_ggtf._qg': 'Acquista ora',
  '_ggtf._mygdl': 'Niente più dati',
  '_ggtf._qgrtd': 'Troppi acquirenti, riprova',
  '_ggtf._hdxq': 'Dettagli evento',
  '_ggtf._hdjs': 'Descrizione evento',
  '_ggtf._cyyq': 'Requisiti partecipazione',
  '_ggtf._zdtz': 'Investimento minimo',
  '_ggtf._vpdj': 'Livello VIP',
  '_ggtf._rjcy': 'Partecipazione media',
  '_ggtf._gmje': 'Importo acquisto',
  '_ggtf._qsrgmje': 'Inserisci importo acquisto',
  '_ggtf._qx': 'Annulla',
  '_ggtf._ljcy': 'Partecipa ora',
  '_ggtf._ssjymm': 'Inserisci password transazioni',
  '_ggtf._qssjymm': 'Inserisci password transazioni',
  '_ggtf._ji': 'Livello',
  '_ggtf._ci': 'volte',
  '_ggtf._zdgm': 'Importo acquisto minimo',
  '_ggtf._zggm': 'Importo acquisto massimo',
  '_ggtf._zfz': 'Elaborazione pagamento...',

  '_wdtg._wjl': 'Nessuna partecipazione ancora',
  '_wdtg._tzje': 'Importo investito',
  '_wdtg._zsy': 'Guadagni totali',
  '_wdtg._hdts': 'Giorni evento',
  '_wdtg._cysj': 'Ora partecipazione',
  '_wdtg._qzf': 'Vai a pagare',
  '_wdtg._jxz': 'In corso',
  '_wdtg._djszje': 'Totale in attesa',
  '_wdtg._gjb': 'Totale {a} elementi',
  '_wdtg._djs': 'In attesa di regolamento',
  '_wdtg._zrsy': 'Guadagni di ieri',
  '_wdtg._dbl': 'Visualizzazioni on-demand',
  '_wdtg._bfl': 'Conteggio riproduzioni',
  '_wdtg._wdsy': 'I miei guadagni',
  '_wdtg._bqffc': 'Quota detentore copyright',
  '_wdtg._mr0djs': 'Regolamento guadagni ieri alle 00:00',
  '_wdtg._jrsy': 'Guadagni oggi',
  '_wdtg._mygd': 'Niente più dati',

  '_bqyy._bqyy': 'Prenotazione collaborazione copyright',
  '_bqyy._qrbq': 'Confermi la prenotazione?',
  '_bqyy._qx': 'Annulla',
  '_bqyy._tjyy': 'Invia prenotazione',

  '_bqyy._spsq': 'Richiesta collaborazione video',
  '_bqyy._spsy': 'Promuovi video insieme per più traffico e guadagni!',
  '_bqyy._ljyy': 'Prenota ora',
  '_bqyy._sphz': "Cos'è la collaborazione copyright?",
  '_bqyy._sphzsm': 'La collaborazione offre più visibilità a beneficio reciproco.',
  '_bqyy._sqhch': 'Vantaggi collaborazione',
  '_bqyy._llfz': 'Supporto traffico',
  '_bqyy._llfzsm': 'Aumenta visibilità e riproduzioni.',
  '_bqyy._sytg': 'Guadagni maggiorati',
  '_bqyy._sytgsm': 'Ottieni maggiori ricavi pubblicitari.',
  '_bqyy._yxhz': 'Collaborazione prioritaria',
  '_bqyy._yxhzsm': 'Partecipa prioritariamente ad eventi ufficiali.',
  '_bqyy._yytj': 'Condizioni prenotazione',
  '_bqyy._sptg': 'Requisiti promozione video',
  '_bqyy._sptgsm': 'Partecipa ad almeno 1 promozione video.',
  '_bqyy._yysm': 'Il nostro staff ti contatterà entro 3 giorni.',

  '_ybp._wdsy': 'I miei guadagni',
  '_ybp._dqye': 'Saldo attuale',
  '_ybp._jr': 'Oggi',
  '_ybp._jrzsy': 'Guadagni totali oggi',
  '_ybp._ljzsy': 'Guadagni totali cumulativi',
  '_ybp._tgfh': 'Dividendi promozione',
  '_ybp._ljsy': 'Guadagni cumulativi',
  '_ybp._bqsy': 'Guadagni copyright',
  '_ybp._yqfh': 'Dividendi inviti',
  '_ybp._mrsy': 'Guadagni giornalieri',
  '_ybp._tgsy': 'Guadagni promozione',

  '_tjdz._tjxd': 'Aggiungi nuovo indirizzo',
  '_tjdz._xzbz': 'Seleziona valuta',
  '_tjdz._qbdz': 'Indirizzo portafoglio',
  '_tjdz._srdz': 'Inserisci indirizzo portafoglio',
  '_tjdz._qx': 'Annulla',
  '_tjdz._bc': 'Salva',

  '_sz._smrz': 'Verifica identità',
  '_sz._rzlx': 'Tipo verifica',
  '_sz._sfzzm': 'Fronte documento',
  '_sz._sfzfm': 'Retro documento',
  '_sz._zsxm': 'Nome reale',
  '_sz._qsrzsxm': 'Inserisci nome reale',
  '_sz._sfzhm': 'Numero documento',
  '_sz._qsrsfzhm': 'Inserisci numero documento',
  '_sz._yyzz': 'Licenza commerciale',
  '_sz._qymc': 'Nome azienda',
  '_sz._yyzzh': 'Numero licenza',
  '_sz._qsrqymc': 'Inserisci nome azienda',
  '_sz._qsryyzzh': 'Inserisci numero licenza',
  '_sz._qx': 'Annulla',
  '_sz._tjrz': 'Invia verifica',
  '_sz._zt': 'Stato',
  '_sz._gr': 'Individuale',
  '_sz._qy': 'Azienda',
  '_sz._shz': 'In revisione',
  '_sz._ytg': 'Approvato',
  '_sz._ybh': 'Rifiutato',

  '_mm._xgmm': 'Cambia password',
  '_mm._dqxg': 'Cambia password regolarmente',
  '_mm._dqmm': 'Password attuale',
  '_mm._xmm': 'Nuova password',
  '_mm._qrxmm': 'Conferma nuova password',
  '_mm._qx': 'Annulla',
  '_mm._qrxg': 'Conferma cambio',

  '_jymm._xgjymm': 'Cambia password transazioni',

  '_szzx._sz': 'Impostazioni',
  '_szzx._yrz': 'Verificato',
  '_szzx._wrz': 'Non verificato',
  '_szzx._jymm': 'Password transazioni',
  '_szzx._szjymm': 'Imposta o modifica password transazioni',
  '_szzx._tcdl': 'Disconnetti',
  '_szzx._qdtcdl': 'Sei sicuro di disconnetterti?',
  '_szzx._qrtc': 'Conferma disconnessione',
  '_szzx._qx': 'Annulla',

  '_yj._gy': 'Informazioni',

  '_yj._lxwm': 'Contattaci',

  '_yj._yszc': 'Informativa sulla privacy',

  '_yj._yhxy': "Contratto d'uso",

  '_cd._gszz': 'Qualifiche aziendali',

  '_cd._wmyy': 'Possediamo qualifiche e certificazioni complete del settore, fornendo agli utenti servizi video legali, sicuri e di alta qualità',

  '_cd._yyzz': "Prova valida dell'attività legale dell'azienda, che dimostri le nostre informazioni di registrazione formali e l'ambito di attività",

  '_cd._yyzz2': "Una licenza commerciale certificata dall'azienda, ottenuta legalmente, che garantisca la legalità e la conformità della piattaforma",

  '_bz._lxkf': 'Clicca qui sotto per contattare il servizio clienti o contattaci tramite il servizio clienti e-mail o hotline',

  '_sz._bjtx': 'Modifica',

  '_sz._bjxx': 'Modifica messaggio',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Salva',

  '_db._zskf': "Contatta l'assistenza",
  '_db._zsry': 'Assistente dedicato',
  '_db._wdq': 'Non letto',
  '_db._ydq': 'Letto',

  '_sc._sctp': 'Carica immagine',
  '_sc._xztp': 'Scegli immagine',
  '_sc._fstp': 'Invia immagine',
  '_sc._qx': 'Annulla',
  '_sc._hd': 'Ok',

  '_zcyl._zcbt': 'Regalo di benvenuto',
  '_zcyl._djdkhb': 'Tocca per aprire la busta rossa',
  '_zcyl._zclj': 'Premio di registrazione',
  '_zcyl._hmyzh': 'Non hai un account?',
  '_zcyl._qzc': 'Registrati',
  '_zcyl._qxdjhb': 'Riscatta prima il tuo premio',
  '_zcyl._qwzc': 'Vai alla registrazione',
  '_zcyl._hbysy': 'Premio già utilizzato',

  '_ggtg._qhz': 'Vai al Bonifico',
  '_ggtg._dqye': 'Saldo Attuale',
  '_ggtg._qcz': 'Vai a Deposita',
  '_ggtg._hzje': 'Importo Trasferimento',
  '_ggtg._ljhz': 'Trasferisci Ora',
  '_ggtg._yebz': 'Saldo Insufficiente',

  '_sq._bhbt': 'Rifiutato',

  '_sq._bhyy': 'Motivo del rifiuto',

  '_xx._ntq': '{n} giorni fa',

  '_xx._nxsq': '{n} ore fa',

  '_xx._nfzq': '{n} minuti fa',

  '_xx._nggq': 'Proprio ora',

  '_xx._djckgd': 'Clicca per vedere di più',

  '_ct._zt': 'Stato',

  '_ct._ljz': 'Connessione in corso',

  '_ct._ylj': 'Connesso',

  '_ct._ltlieb': 'Lista chat',

  '_ct._bnhzj': 'Impossibile chattare con me stesso',

  '_ct._cylb': 'Lista membri',

  '_hb._fhb': 'Busta rossa',

  '_hb._dqye': 'Saldo attuale',

  '_hb._fsd': 'Inviato a',

  '_hb._hbje': 'Importo busta rossa',

  '_hb._qshuru': "Inserisci l'importo della busta rossa",

  '_hb._ljfs': 'Invia Ora',

  '_hb._hbz': 'Benedizione della busta rossa',
  '_hb._qshuruzhu': 'Inserisci la tua benedizione',

  '_sp._cuow': 'Gli episodi da 1 a 10 devono essere sbloccati prima di poterli guardare',

  '_bq._tzzq': 'Periodo di investimento',

  '_bq._zrsy': 'Profitto di ieri',

  '_bq._bqtz': 'Investimento in copyright',

  '_bq._tzdj': "Importo dell'investimento",

  '_bq._zfjz': 'Il pagamento deve essere effettuato entro 24 ore, altrimenti verrà considerato nullo!',

  '_bq._qzf': 'Effettua il pagamento',

  '_bq.jz': 'Scadenza',

  '_bq._ljzf': 'Paga ora',

  '_bq._sqbz': 'Note sulla domanda (facoltative)',

  '_bq._sqbzsm': "Inserisci i dati della domanda' Note",

  '_bq._zzsqz': 'Richiesta di copyright in corso, in attesa di revisione...',

  '_app._xz': "Scarica l'applicazione ReelShortBiz",

  '_app._smerm': 'Scansiona il codice QR per scaricare',

  '_app._xzbt': 'Scarica',

  '_m._yhzz': 'Bonifico bancario',
  '_m._yhxx': 'Informazioni bancarie',
  '_m._yhmz': 'Nome banca',
  '_m._yhdz': 'Indirizzo banca',
  '_m._yhmc': 'Nome',
  '_m._yhzh': 'Conto',
  '_m._yhlx': 'Tipo',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Codice',
  '_m._yhbz': 'Nota',
  '_m._fzxx': 'Copia informazioni',

  '_m._zts': 'Consigli',

  '_m._zyd1': '1. Si prega di verificare attentamente il nome del destinatario, il numero di conto e il codice bancario al momento del trasferimento. Qualsiasi errore potrebbe comportare la perdita del bonifico.',

  '_m._zyd2': "2. Si consiglia di selezionare 'Il mittente si fa carico di tutte le commissioni' per evitare fondi insufficienti a causa delle detrazioni bancarie intermedie.",

  '_m._zyd3': '3. I trasferimenti richiedono solitamente da 1 a 3 giorni lavorativi. Si prega di essere pazienti. Per qualsiasi domanda, si prega di contattare il servizio clienti.',

  '_m._zyd4': '4. Per qualsiasi altra domanda, si prega di contattare il servizio clienti.',

  '_m._jyh': 'Numero di transazione',

  '_m._jyje': 'Importo',

  '_sp._dbye': 'Saldo VOD',
  '_sp.hzye': 'Trasferimento',
  '_sp._txje': 'Importo del trasferimento',
  '_sp._qsrtxje': "Si prega di inserire l'importo del trasferimento",
  '_sp._ljhz': 'Trasferisci ora',
  '_sp._yebz': 'Saldo insufficiente',
  '_sp._qshuru': "Si prega di inserire l'importo corretto del trasferimento",
  '_sp._fanh': 'Indietro',

  '_sp._tliu': 'Pubblicità',
  '_sp._xzgj': 'Seleziona paese',
  '_sp._cdcw': 'Errore di codifica video',
  '_ggtf._hot': 'Tendenza',
  '_tl._tlsj': 'Orario pubblicità',
  '_tl._xzxb': 'Seleziona sesso',
  '_tl._nan': 'Maschio',
  '_tl._nv': 'Femmina',
  '_tl._hunhe': 'Misto',
  '_tl._xznl': 'Seleziona età',
  '_sp._us': 'Stati Uniti',
  '_sp._en': 'Regno Unito',
  '_sp._jp': 'Giappone',
  '_sp._fr': 'Francia',
  '_sp._kr': 'Corea del Sud',
  '_sp._de': 'Germania',
  '_sp._id': 'India',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Australia',
  '_sp._es': 'Spagna',
  '_sp._my': 'Malesia',
  '_sp._cn': 'Cina',
  '_ggtf._fanhui': 'Indietro',
  '_ggtf._jymmts': "Conferma l'importo della transazione e inserisci la password",
  '_wdtg._wjl_desc': 'Non hai ancora partecipato a nessuna campagna pubblicitaria',
  '_wd._jxz': 'In corso',
  '_wd._djs': 'In attesa di liquidazione',
  '_wd._ywc': 'Completato',
  '_wd._jz': 'Urgente',
  '_wd._hz': 'Trasferimento',

  '_tl._tlfbqk': 'Distribuzione della spesa pubblicitaria',
  '_tl._tlfbqk_desc': 'Giorni 1-5: 5% (Fase di avvio a freddo), Giorni 6-10: 20% (Fase di validazione dei contenuti), Giorni 11-15: 40% (Fase di costruzione IP), Giorni 16-20: 35% (Fase di matrice di miniserie)',

  '_nhz._sm': "Dopo il trasferimento, l'importo verrà trasferito sul portafoglio video per sbloccare i contenuti video",
  '_nhz._zhzz': 'Trasferimento in corso...',
  '_nhz._zzcg': 'Trasferimento riuscito',
  '_nhz._zhzsb': 'Trasferimento fallito, riprova',
  '_m._fzcg': 'Copiato con successo',
  '_m._fzsb': 'Copia fallita, copia manualmente',
  '_m._zwfzxx': 'Nessuna informazione da copiare',
  '_tx._qb': 'Tutti',
  'activity.detail': "Dettagli dell'attività",
  'activity.noDesc': "Nessuna descrizione dell'attività",
  'activity.desc': "Descrizione dell'attività",
  'activity.requirements': 'Requisiti di partecipazione',
  'activity.minInvest': 'Investimento minimo',
  'activity.vipLevel': 'Livello VIP',
  'activity.avgParticipation': 'Partecipazione media',
  'activity.avgParticipationDesc': 'volte',
  'activity.country': 'Seleziona paese',
  'activity.deliveryTime': 'Tempo di pubblicità',
  'activity.deliveryTimeDesc': 'giorni',
  'activity.gender': 'Seleziona genere',
  'activity.male': 'Maschio',
  'activity.female': 'Femmina',
  'activity.mixed': 'Misto',
  'activity.age': 'Seleziona età',
  'activity.amount': "Importo d'acquisto",
  'activity.back': 'Indietro',
  'activity.join': 'Partecipa ora',
  emptyData: 'Nessun dato',
  emptyDataDesc: 'Nessuna campagna pubblicitaria partecipante',
  completedtlement: 'Scaduto',
  preheat: 'Preriscaldamento',
  progress: 'In corso',
  settlement: 'In attesa di liquidazione',
  transfered: 'Trasferito',
  completed: 'Completato',
  activityCode: 'Codice attività',
  touzAmount: "Importo dell'investimento",
  activityDays: 'Giorni di attività',
  joinTime: 'Orario di partecipazione',
  playSource: 'Distribuzione delle fonti di riproduzione',
  allPlatforms: 'Tutte le piattaforme',
  other: 'Altro',
  totalPlayNum: 'Riproduzioni totali',
  incomeSummary: 'Riepilogo dei redditi',
  totalPay: 'Commissioni di copyright pagate',
  totalIncome: 'Reddito totale',
  copyrightRatio: 'Quota del titolare dei diritti',
  promotionIncome: 'Reddito da promozione',
  copyrightIncome: 'Quota di copyright',
  playNum: 'Riproduzioni',
  buyNum: 'Riproduzioni on-demand',
  incomeRate: 'Tasso di condivisione',
  yjIncome: 'Reddito stimato',
  paid: 'Pagato',
  timeout: 'Scaduto',
  transfer: 'Trasferisci ora',
  loading: 'Caricamento...',
  loadMore: 'Carica altro',
  noMore: 'Niente altro',
  nightTime: 'Periodo notturno',
  morningTime: 'Periodo mattutino',
  afternoonTime: 'Periodo pomeridiano',
  eveningTime: 'Periodo serale',
  '_h._tc': 'Esci',
  periodPayment: 'Pagamento per periodo',
  periodPaymentDesc: 'La liquidazione avviene 4 volte al giorno in 4 periodi, è possibile pagare le commissioni di copyright per periodo',

  day: 'giorno',
  '_dl._hy': 'Bentornato',
  '_dl._cj': 'Crea account',
  '_dl._zmm': 'Reimposta password',
  '_dl._hyDesc': 'Accedi al tuo account per continuare a esplorare contenuti fantastici',
  '_dl._cjDesc': 'Unisciti a ReelShortBiz e inizia il tuo emozionante viaggio',
  '_dl._zmmDesc': 'Inserisci la tua email e ti invieremo un codice di verifica per reimpostare',
  '_dl._hlgqsp': 'Ampia libreria di film e video in HD',
  '_dl._gxhty': 'Algoritmi di raccomandazione personalizzati',
  '_dl._ffddsp': 'Video brevi ricchi e vari',
  '_dl._dlzh': 'Accedi',
  '_dl._sdndyx': 'Inserisci la tua email e password per continuare',
  '_dl._email': 'Indirizzo email',
  '_dl._qsryx': 'Inserisci il tuo indirizzo email',
  '_dl._dlmm': 'Password',
  '_dl._qsrmm': 'Inserisci la tua password',
  '_dl._wjmm': 'Password dimenticata?',
  '_dl._immdl': 'Accedi ora',
  '_dl._hmyzh2': 'Non hai un account?',
  '_dl._ljzc2': 'Registrati ora',
  '_dl._cjzh': 'Crea account',
  '_dl._jswmd': 'Unisciti a ReelShortBiz e inizia il tuo emozionante viaggio',
  '_zh._qszmm': 'Imposta la tua password',
  '_zh._qrmm': 'Conferma password',
  '_zh._qmm': 'Inserisci di nuovo la password',
  '_zc._yqm': 'Codice invito',
  '_zc._sryqm': 'Inserisci il codice invito',
  '_dl._yzm': 'Codice di verifica',
  '_dl._qsryzm': 'Inserisci il codice di verifica',
  '_dl._yjyzh': 'Hai già un account?',
  '_dl._zcbsty2': 'Registrandoti accetti',
  '_dl._zcbstyDesc': 'Politica sulla privacy',
  '_dl._newmm': 'Nuova password',
  '_dl._qszxmm': 'Imposta una nuova password',
  '_dl._qrmm': 'Conferma password',
  '_dl._qzcsrmm': 'Inserisci di nuovo la nuova password',
  '_dl._czmm': 'Reimposta password',
  '_dl._xqlmm': 'Hai ricordato la password?',
  '_dl._fhdl': 'Torna al login',
  '_dl._srdllmmbyz': 'Le password non corrispondono',
  '_dl._czcg': 'Password reimpostata con successo',
  '_h._zc': 'Registrati',
  // '_ybp._wdsy': 'I miei guadagni',
  '_ybp._jrsy': 'Guadagni di oggi',
  '_ybp._jztr': 'Rispetto a ieri',
  '_ybp._bfl': 'Visualizzazioni',
  '_ybp._dbl': 'Richieste',
  '_ybp._syqs': 'Andamento guadagni',
  // '_ybp._jr': 'Oggi',
  '_ybp._t': 'giorno',
  // '_ybp._dqye': 'Saldo account',
  '_ybp._djs': 'In attesa di liquidazione',
  '_ybp._zhl': 'Tasso di conversione',
  '_ybp._sjgl': 'Panoramica dati',
  '_ybp._zrsy': 'Guadagni di ieri',
  '_ybp._bysy': 'Guadagni di questo mese',
  '_ybp._yysj': 'Dati operativi',
  '_ybp._zr': 'Ieri',
  '_ybp._zjfrs': 'Utenti paganti totali',
  '_ybp._mtdqje': 'Importo dovuto domani',
  '_ybp._jsy': 'Guadagni netti',
  '_ybp._bqfy': "Piano di pagamento dei diritti d'autore",
  '_ybp._yzf': 'Pagato',
  '_ybp._qzf': 'Vai a pagare',
  '_ybp._bqfyts': "Dopo il pagamento dei diritti d'autore, i tuoi guadagni e diritti saranno prioritari",
  '_ybp._syjl': 'Storico guadagni',
  '_ybp._ckgd': 'Vedi di più',
  '_ybp._ssdt': 'Aggiornamenti in tempo reale',
  '_ybp._bzzx': 'Centro assistenza',
  '_ybp._lxkf': 'Contatta il supporto',
  '_ybp._zrxz': 'Guadagni di ieri',
  '_ybp._zdsy': 'Guadagni totali',
  '_ybp._qygy': 'Mese scorso',
  '_ybp._jsjl': 'Storico liquidazioni',
  '_ybp._hzjl': 'Storico trasferimenti',
  '_ybp._jfzq': 'minuti fa',
  '_ybp._fzq': 'ore fa',
  '_ybp._djs_mt': 'Importo liquidazione domani',
  '_yj._rule': 'Regole della piattaforma',

  '_bq._jjks': 'Inizia ora',
  '_bq._jxz': 'In corso',
  '_bq._jks': "Tempo all'inizio",
  '_bq._jjs': 'Tempo alla fine',
  '_bq._t': 'g',
  '_bq._h': 'h',
  '_bq._m': 'min',
  '_bq._s': 's',
  '_bq._kssj': 'Ora di inizio',
  '_bq._jssj': 'Ora di fine',
  '_bqq._tzdj': 'Prezzo unitario',
  '_bqq._hdts': 'Giorni di evento',
  '_bqq._vip': 'Livello VIP',
  '_bqq._rjcy': 'Partecipazione media',
  '_bqq._cs': 'volte',
  '_bqq._ysjd': 'Avanzamento vendite',
  '_bqq._ljqg': 'Acquista ora',
  '_bqq._zbkqg': 'Attualmente non disponibile',
  '_bqq._jzz': 'Caricamento',
  '_bqq._jzgd': 'Carica altro',
  '_bqq._wz': 'Niente altro',

  '_sp._gdsj': 'Totale {n} episodi',
  '_sy._jl': 'Registro pagamenti in sospeso',
  '_ybp._zsy': 'Entrate totali',
  '_ybp._djsjl': 'Registro pagamenti in sospeso',
  '_ybp._bqbm': 'Codice',
  '_ybp._je': 'Importo',
  '_ybp._sj': 'Orario',
  '_sy._djs': 'In sospeso',
  '_sy._yjs': 'Liquidato',
  '_sy._gdstjl': 'Totale {n} registrazioni',
  '_sy._gjd': 'Totale {n}'
}
